import { useSearchParams } from 'react-router-dom'
import { useQuery } from '@apollo/client/react'
import Error from '@components/Error/Error'
import PageHeading from '@components/PageHeading/PageHeading'
import Pagination from '@components/Pagination/Pagination'
import Search from '@components/pages/TransactionBatch/Search'
import Table from '@components/pages/TransactionBatch/ListTable'
import GET_TRANSACTION_BATCHES from '@graphql/queries/get-transaction-batches'

function List() {
  const [searchParams, setSearchParams] = useSearchParams()
  const searchFilters = Object.fromEntries(searchParams)
  const { data, loading, error, refetch } = useQuery(GET_TRANSACTION_BATCHES, {
    variables: { filters: searchFilters }
  })

  return (
    <>
      <PageHeading heading='Transaction Batches' />

      {error ? (
        <Error error={error} />
      ) : (
        <>
          <Search
            refetch={refetch}
            searchFilters={searchFilters}
            setSearchParams={setSearchParams}
          />
          <Pagination
            onPageChange={(page) => setSearchParams({ ...searchFilters, page })}
            pageMetadata={data?.transactionBatches?.metadata}
          />
          <Table
            totalCount={data?.transactionBatches?.metadata?.totalCount}
            transactionBatches={data?.transactionBatches?.collection || []}
            loading={loading}
          />
          <Pagination
            onPageChange={(page) => setSearchParams({ ...searchFilters, page })}
            pageMetadata={data?.transactionBatches?.metadata}
          />
        </>
      )}
    </>
  )
}

export default List
